/** Gradient — fill each mark with a gradient between your first and last swatch. */
import type { AffectModule } from '../../core/module-api';
import { cfgNum } from '../../core/module-api';
import { cloneShape } from '../../core/scene';
import { bbox } from '../../core/geometry';

const ICON =
  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M3 9h18" opacity="0.5"/><path d="M3 15h18" opacity="0.5"/></svg>';

export function createGradient(): AffectModule {
  return {
    manifest: {
      id: 'gradient',
      kind: 'affect',
      name: 'Gradient',
      apiVersion: 1,
      description: 'Fill the mark with a gradient between your first and last swatch.',
      icon: ICON,
      params: [{ kind: 'slider', key: 'angle', label: 'Angle', min: 0, max: 360, step: 5, default: 90 }],
    },

    affect(shapes, ctx) {
      const angle = (cfgNum(ctx.config, 'angle', 90) * Math.PI) / 180;
      const cols = ctx.palette.colors;
      const c1 = cols[0] ?? ctx.ink;
      const c2 = cols[cols.length - 1] ?? ctx.ink;
      const dx = Math.cos(angle);
      const dy = Math.sin(angle);
      return shapes.map((s) => {
        const c = cloneShape(s);
        const b = bbox(s.path);
        const cx = (b.minX + b.maxX) / 2;
        const cy = (b.minY + b.maxY) / 2;
        const r = Math.max(1, Math.hypot(b.maxX - b.minX, b.maxY - b.minY) / 2);
        c.gradient = {
          from: { x: cx - dx * r, y: cy - dy * r },
          to: { x: cx + dx * r, y: cy + dy * r },
          stops: [
            { offset: 0, color: { ...c1 } },
            { offset: 1, color: { ...c2 } },
          ],
        };
        return c;
      });
    },
  };
}
